import { render, staticRenderFns } from "./GeographyArea.vue?vue&type=template&id=120ae25d&scoped=true&"
import script from "./GeographyArea.vue?vue&type=script&lang=js&"
export * from "./GeographyArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ae25d",
  null
  
)

export default component.exports